import { render, staticRenderFns } from "./management-option.vue?vue&type=template&id=26b1e47e&scoped=true&"
import script from "./management-option.vue?vue&type=script&lang=tsx&"
export * from "./management-option.vue?vue&type=script&lang=tsx&"
import style0 from "./management-option.vue?vue&type=style&index=0&id=26b1e47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b1e47e",
  null
  
)

export default component.exports